export default "./filter.svg"